import { IconContext } from 'react-icons';
import { FaQuestionCircle } from 'react-icons/fa';
import React from 'react';
import './InfoBulle.scss'
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { sanitizedMsg } from "../../../utils/htmlUtils";

export default function InfoBulle(
    {
        classes,
        info,
    }
) {

    return (
        <>
            { info ? (
                <div className="d-flex justify-content-end">

                    <OverlayTrigger
                        placement={ 'top' }
                        delay={{ show: 100, hide: 150 }}
                        trigger={['hover', 'focus', 'click']}
                        overlay={
                            <Tooltip>
                                <span dangerouslySetInnerHTML={ sanitizedMsg(info) }/>
                            </Tooltip>
                        }
                    >
                        <div className={ `btn info-bulle shrink-height ${classes ? classes : ''}` }>
                            <IconContext.Provider value={ { style: { fontSize: '1.25rem' } } }>
                                <FaQuestionCircle />
                            </IconContext.Provider>
                        </div>
                    </OverlayTrigger>
                </div>
            ) : '' }
        </>
    )
}